/* Preload all JC preview images */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.jc-card-swatch[data-preview-image]').forEach(function (swatch) {
    const src = swatch.getAttribute('data-preview-image');
    if (!src) return;

    const img = new Image();
    img.src = src;
  });
});

document.addEventListener('mouseover', function (event) {
  const swatch = event.target.closest('.jc-card-swatch');
  if (!swatch) return;

  const swatchGroup = swatch.closest('.jc-card-swatches');
  if (!swatchGroup) return;

  const previewLayer = swatchGroup.previousElementSibling;
  if (!previewLayer || !previewLayer.classList.contains('jc-card-preview')) return;

  const previewImage = previewLayer.querySelector('img');
  const previewSrc = swatch.getAttribute('data-preview-image');

  if (!previewImage || !previewSrc) return;

  previewImage.src = previewSrc;
  previewImage.alt = swatch.getAttribute('title') || '';

  previewLayer.classList.add('is-active');
});

document.addEventListener('mouseout', function (event) {
  const swatch = event.target.closest('.jc-card-swatch');
  if (!swatch) return;

  if (event.relatedTarget && swatch.contains(event.relatedTarget)) return;

  const swatchGroup = swatch.closest('.jc-card-swatches');
  if (!swatchGroup) return;

  const previewLayer = swatchGroup.previousElementSibling;
  if (!previewLayer || !previewLayer.classList.contains('jc-card-preview')) return;

  previewLayer.classList.remove('is-active');
});